Customer.Dashboard ||= {}

class Customer.Dashboard.EmailTextExtraActionsView extends Backbone.View
  template: JST['backbone/templates/customer/ticket/body/email_text_extra_actions']

  events:
    'click #notes-icon' : '_onAddNotes'
    'click #icon-signature' : '_onAddSignature'
    'click #schedule' : '_onScheduleResponse'
    'click #add-attachment' : '_onAddAttachment'

  initialize: ({ notes, schedule }) ->
    @notesEnabled = notes
    @scheduleEnabled = schedule

  render: ->
    @$el.html(@template(notesEnabled: @notesEnabled, scheduleEnabled: @scheduleEnabled))
    @

  noSignatureTooltip: ->
    @$el.find('#icon-signature').tooltip('show').attr('data-original-title', I18n.t('customer.dashboard.conversations.details.response.no_signatures_available')).tooltip('fixTitle')
    @$el.find('#icon-signature').tooltip('show')

  _onAddNotes: ->
    @trigger('email:action:add:note')

  _onAddSignature: ->
    @trigger('email:action:add:signature')

  _onScheduleResponse: ->
    @trigger('email:action:schedule:response')

  _onAddAttachment: ->
    @trigger('email:action:add:attachment')
